var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useForward } from '../../../common/hooks';
import { InputRoot } from './../components/input-root';
import { useAutocompleteInput } from './autocomplete.hook';
import { AutocompleteSelected, AutocompletePanelList } from './components';
export var Autocomplete2 = React.forwardRef(function (_a, ref) {
    var panelHeader = _a.panelHeader, panelListHeader = _a.panelListHeader, panelFooter = _a.panelFooter, inputStyle = _a.inputStyle, props = __rest(_a, ["panelHeader", "panelListHeader", "panelFooter", "inputStyle"]);
    var forwardRef = useForward(ref);
    var _b = useAutocompleteInput(props, forwardRef), container = _b.container, input = _b.input, autoCompleteProps = __rest(_b, ["container", "input"]);
    return _jsx(_Fragment, { children: _jsxs(InputRoot, __assign({}, props, container, { panelContent: (_jsx(AutocompletePanelList, __assign({ displayKey: props.displayKey, listKey: props.listKey, header: panelHeader, listHeader: panelListHeader, footer: panelFooter }, autoCompleteProps))) }, { children: [autoCompleteProps.selected &&
                    _jsx(AutocompleteSelected, __assign({}, autoCompleteProps, { displayKey: props.displayKey, selectedKey: props.selectedKey })), _jsx("input", __assign({}, input, { ref: forwardRef, readOnly: Boolean(autoCompleteProps.selected) || input.readOnly, style: __assign(__assign({}, inputStyle), { maxWidth: Boolean(autoCompleteProps.selected) ? 1 : undefined }) }))] })) });
});
